import { Items } from "@pdfking/tfunc"

import { getter } from "./getter"
import { is_object } from "./is_object"
import { ordered_object } from "./ordered_object"
import { to_array } from "./to_array"

export const filter = (f, iterable) => {
  // we want to return a new object if iterable is an object

  const g = getter(f)

  if (is_object(iterable)) {
    // @ts-expect-error - getter may accept 2 args
    return ordered_object(Items(iterable).filter(a => g(a[1], a[0])))
  }
  return to_array(iterable).filter(g)
}
